import React, { useMemo } from 'react';

import hexWithAlpha from '../../../../../../utils/hexWithAlpha';

import scss from '../WritersList.module.scss';

const ColoredName = ({ name, color }) => {
  const colorWithAlpha = useMemo(() => hexWithAlpha({ hex: color, alpha: 80 }), [color]);

  return (
    <div className={scss.coloredNameWrapper} style={{ backgroundColor: colorWithAlpha }}>
      <span className={scss.coloredNameLabel}>{name}</span>
    </div>
  );
};

export default ColoredName;
